import { render, staticRenderFns } from "./TariffPremiumList.vue?vue&type=template&id=d623f5f6&"
import script from "./TariffPremiumList.vue?vue&type=script&lang=js&"
export * from "./TariffPremiumList.vue?vue&type=script&lang=js&"
import style0 from "./TariffPremiumList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TariffPremiumList.vue"
export default component.exports